import React from "react";

import { Alert } from "~/components/alert";

export function CannotUnmuteAlert() {
	return (
		<Alert variant="warning">
			<strong className="font-semibold">You cannot unmute the current monitor</strong> either because it was muted by an
			external application or because you are not authorized to do so.
		</Alert>
	);
}
